import React, { useState } from 'react';
import Button from '@mui/material/Button';
import { Stack } from '@mui/system';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import DeleteIcon from '@mui/icons-material/Delete';

import AddCustomColourModal from '../../brandManagement/modal/AddCustomColourModal';
import { Alert, Card, CardContent, CardMedia, IconButton } from '@mui/material';

const hexToRgb = (hex) => {
    hex = hex.replace(/^#/, '');
    const bigint = parseInt(hex, 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;
    return { r, g, b };
};

const CustomColourPanel = ({ account, onFormChange }) => {
    const [customColourDialog, setCustomColourDialog] = useState(false);
    const [customColours, setCustomColors] = useState(account.customColours);

    const handleOnSubmit = async (colour, label) => {
        setCustomColors([...customColours, { value: colour, label: label }]);
        onFormChange('customColours', [...customColours, { value: colour, label: label }]);
        setCustomColourDialog(false);
    };

    const handleDeleteColour = async (index) => {
        const updatedColours = customColours.filter((_, key) => key !== index);

        setCustomColors(updatedColours);
        onFormChange('customColours', updatedColours);
    };

    return (
        <>
            <Box>
                <Button variant="contained" onClick={() => setCustomColourDialog(true)}>Add Brand Colour</Button>
                {account.customColours.length > 0 ? (
                    <Box sx={{ flexGrow: 1, mt: 2, width: '100%' }}>
                        <Grid
                            container
                            spacing={2}
                        >
                            {account.customColours.map((colour, index) => {
                                const rgb = hexToRgb(colour.value);
                                return (
                                    <Grid
                                        size={{ xs: 12, sm: 6, md: 3 }}
                                        key={colour.id ?? index}
                                    >
                                        <Card
                                            sx={{
                                                borderRadius: 5,
                                                display: 'flex',
                                                flexDirection: 'column'
                                            }}
                                        >
                                            <CardMedia
                                                sx={{
                                                    backgroundColor: colour.value,
                                                    borderTopLeftRadius: 8,
                                                    borderTopRightRadius: 8,
                                                    aspectRatio: '16 / 9'
                                                }}
                                            />

                                            <CardContent sx={{ pt: 1 }}>
                                                <Stack direction="row" alignItems="start" spacing={1}>
                                                    <Typography
                                                        variant="h6"
                                                        title={colour.label ?? ''}
                                                        sx={{
                                                            flexGrow: 1,
                                                            wordBreak: 'break-word'
                                                        }}
                                                    >
                                                        {colour.label ?? ''}
                                                    </Typography>

                                                    <IconButton
                                                        onClick={() => handleDeleteColour(index)}
                                                        size="small"
                                                    >
                                                        <DeleteIcon fontSize="small" />
                                                    </IconButton>
                                                </Stack>

                                                <Stack spacing={0.2}>
                                                    <Typography variant="subtitle2" color="text.secondary">
                                                        HEX: {colour.value}
                                                    </Typography>
                                                    <Typography variant="subtitle2" color="text.secondary">
                                                        RGB: ({rgb.r}, {rgb.g}, {rgb.b})
                                                    </Typography>
                                                </Stack>
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                );
                            })}
                        </Grid>
                    </Box>
                ) : (
                    <Alert sx={{ mt: 2 }} severity="info">No brand colours available.</Alert>
                )}
            </Box>
            {customColourDialog && (
                <AddCustomColourModal
                    shown={customColourDialog}
                    onHide={() => setCustomColourDialog(false)}
                    onSubmit={handleOnSubmit}
                />
            )}
        </>
    );
};

export default CustomColourPanel;